/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ports: NonNullable<unknown>, countries: NonNullable<unknown> }} Home_Reason_Anywhere_TextInputs */



/**
* | output |
* | --- |
* | "Attendance in more than {ports} ports across {countries}+ countries." |
*
* @param {Home_Reason_Anywhere_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_reason_anywhere_text = /** @type {((inputs: Home_Reason_Anywhere_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reason_Anywhere_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`服务覆盖 ${i?.countries}+ 个国家的超过 ${i?.ports} 个港口。`)
	return /** @type {LocalizedString} */ (`Attendance in more than ${i?.ports} ports across ${i?.countries}+ countries.`)
});